import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter, Route, Switch } from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import { Provider } from 'react-redux';
//import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import Loadable from 'react-loadable';
import Keycloak from "keycloak-js";
import axios from "axios";
import * as serviceWorker from './serviceWorker';

import 'boosted/dist/css/orangeHelvetica.min.css'
import './App.scss';
import 'react-toastify/dist/ReactToastify.min.css';
import './index.css';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);
// Containers
const Layout = Loadable({
  loader: () => import('./Layouts/Layout'),
  loading
});

let baseURL = "/omoney",
publicUrl = "/omoney/client/build";

if(window.location.origin.indexOf('localhost') != -1) {
    baseURL = 'http://localhost/recuom';
    publicUrl = '';
}
const keycloak = Keycloak(publicUrl +'/assets/keycloak.json');
let client = axios.create({
    baseURL ,
    headers : {
        "Content-Type": 'application/json'
    }
});
// client.interceptors.request.use(config=> {
//     config.headers.Authorization = 'Bearer ' + keycloak.token;

//     if(keycloak.isTokenExpired(1)) keycloak.logout();
    
//     keycloak.updateToken(250)

//     return config;
// });

store.getState().authentication = {
    isLoggedIn: false,
    user: {} ,
    client,
    keycloak,
    publicUrl
 }

const app = (<Provider store={store}>
            <BrowserRouter>
                <Switch>
                    <Route path="/" name="Home" component={Layout} />
                </Switch>
            </BrowserRouter>
        </Provider>);



 ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();


